var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LocalStorageService } from '../../services/LocalStorageService';
import { SharePointService } from '../../services/SharePointService';
import { LanguageHelper } from './LanguageHelper';
var SnippetHelper = (function () {
    function SnippetHelper() {
        this.localStorageKeyPrefix = "TD";
        this.localSnippetStorageKeyName = "Snippet";
    }
    // get snippet from local storage
    SnippetHelper.getSnippet = function (snippetID) {
        var _this = this;
        // check the current local language (languageHelper)
        // make sure we have snippetData in local storage (if not, then run getSnippetData());
        // use the local language to get the relevant snippet from local storage
        // could potentially return multiple items - would have to return an object??
        // return the snippet/snippet object
        var p = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var locale;
            return __generator(this, function (_a) {
                locale = LanguageHelper.getCurrentLocale().Locale;
                // console.log("locale: ");
                // console.log(locale);
                // check if we have snippetData in local storage
                SnippetHelper.getSnippetData().then(function (value) {
                    // console.log(value.tda);
                    // convert results to array
                    var dataArray = Object.keys(value.tda).map(function (key) { return value.tda[key]; });
                    // console.log(dataArray);
                    // var snippetArray: ISnippet[];
                    var snippetArray = [];
                    var arrayHasOrder = true;
                    for (var i = 0; i < dataArray.length; i++) {
                        // look for the snippetIDs and languages that match
                        // console.log("dataArray[i].adminID: " + dataArray[i].adminID);
                        if (snippetID == dataArray[i].adminID) {
                            // console.log("dataArray[i].lang: " + dataArray[i].lang);
                            if (locale == dataArray[i].lang) {
                                // save to an array and return
                                // console.log("push!");
                                snippetArray.push(dataArray[i]);
                                if (dataArray[i].order == null) {
                                    arrayHasOrder = false;
                                }
                            }
                        }
                        // console.log(dataArray[i].category);
                    }
                    // console.log("final snippetArray");
                    // console.log(snippetArray);
                    // console.log("arrayHasOrder: " + arrayHasOrder);
                    if (arrayHasOrder) {
                        snippetArray.sort(function (a, b) { return a.order - b.order; });
                    }
                    resolve(snippetArray);
                    // return snippetArray; // cannot return the snippet, can only resolve the snippet
                });
                return [2 /*return*/];
            });
        }); });
        return p; // must return the promise
    };
    SnippetHelper.getSnippetData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var p;
            return __generator(this, function (_a) {
                p = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var snippetData, localStorageService, localStorageKeyValue, err_1, sharePointService, spContext, results, adminObj, err_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                localStorageService = new LocalStorageService();
                                localStorageKeyValue = {
                                    keyName: "snippet",
                                    keyPrefix: "TD",
                                    timeOutInMinutes: 240 //this.localAdStorageTimeout
                                };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, localStorageService.get(localStorageKeyValue)];
                            case 2:
                                // console.log("inside try");
                                //try and get cached results from local storage
                                snippetData = _a.sent();
                                // console.log("cached results?")
                                // console.log(snippetData);
                                if (snippetData) {
                                    // //appear to have valid cached results, resolve these
                                    // console.log("cached results");
                                    // console.log(snippetData);
                                    resolve(snippetData);
                                    return [2 /*return*/]; // end the promise
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                err_1 = _a.sent();
                                //we are going to ignore error; after failing, we continue down to the next section to pull data from the feed instead
                                console.log("error");
                                console.log(err_1);
                                reject("ErrGetSnippetDataLocalStorage");
                                return [3 /*break*/, 4];
                            case 4:
                                if (!!snippetData) return [3 /*break*/, 9];
                                sharePointService = new SharePointService({
                                    useLocalStorage: true,
                                    localStorageTimeout: 240,
                                    enableLog: false
                                });
                                _a.label = 5;
                            case 5:
                                _a.trys.push([5, 7, , 8]);
                                spContext = window["_spPageContextInfo"];
                                // console.log(spContext);
                                if (!spContext) {
                                    reject("contextRequired");
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, sharePointService.getPagedResults(spContext.siteAbsoluteUrl + "/_api/web/lists/GetByTitle('Admin')/items")];
                            case 6:
                                results = _a.sent();
                                adminObj = {};
                                results.forEach(function (item) {
                                    var url_desc = "";
                                    var url_title = "";
                                    if (item.TT_AdminURL) {
                                        url_desc = item.TT_AdminURL.Description;
                                        url_title = item.TT_AdminURL.Url;
                                    }
                                    adminObj[item.ID] = {
                                        "category": item.TT_AdminCategory,
                                        "adminID": item.TT_AdminID,
                                        "icon": item.TT_AdminIcon,
                                        "lang": item.TT_AdminLanguage,
                                        "openNew": item.TT_AdminOpenNew,
                                        "order": item.TT_AdminOrder,
                                        "snippet": item.TT_AdminSnippet,
                                        "url": {
                                            "description": url_desc,
                                            "url": url_title
                                        }
                                    };
                                });
                                // console.log(adminObj);
                                // console.log("push adminObj to localStorage");
                                localStorageKeyValue.keyValue = { "tda": adminObj };
                                localStorageService.set(localStorageKeyValue);
                                // resolve(spResponse)
                                // return adminObj;
                                resolve(localStorageKeyValue.keyValue);
                                return [3 /*break*/, 8];
                            case 7:
                                err_2 = _a.sent();
                                console.log("an error occurred attempting to make a SP request");
                                console.log(err_2);
                                reject("ErrGetSnippetDataSPRequest");
                                return [3 /*break*/, 8];
                            case 8: return [3 /*break*/, 10];
                            case 9:
                                // we should never get here because snippetData should have been resolved on top
                                resolve(snippetData);
                                _a.label = 10;
                            case 10: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, p]; // returning the promise
            });
        });
    };
    /**
     * Function used by page layouts to inject localized headings
     * @param snippet
     * @param dom
     */
    SnippetHelper.locSnippet = function (snippet, dom) {
        var snip = this.getSnippet(snippet);
        var snipLoc;
        snip.then(function (snipval) {
            snipLoc = snipval[0].snippet;
            document.getElementById(dom).innerHTML = snipLoc;
        });
    };
    return SnippetHelper;
}());
export { SnippetHelper };

//# sourceMappingURL=SnippetHelper.js.map
